import { APP } from 'src/Configs/App'
import { PaymentStatusEnum } from 'src/Constants/enums'
import { formatDate } from 'src/Constants/formatDate'
import _dayjs from 'src/Helpers/dayjs'
import { rtkApi } from 'src/Services/rtkApi'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { TransactionTypeEnum } from 'src/Types/payments'

interface BalanceTrack {
  trackName: string
  trackAuthorName: string
}

interface ArtistBalanceItemResponse {
  amount: string
  createdAt: string
  trackName: string
  typeTransaction: string
  packageName?: string
  artistName: string
  platformType: CampaignPlatformTypeEnum
  campaignId: number | null
  referralData?: {
    firstName: string
    trackName: string
  }
  invitedData?: {
    firstName: string
  }
}

export interface ArtistBalanceItem {
  id: string
  date: string
  createdAt?: string
  transactionType: TransactionTypeEnum
  packageName?: string
  track: BalanceTrack
  amount: number
  campaignId: number | null
  platformType: CampaignPlatformTypeEnum
  referralData?: {
    firstName: string
    trackName: string
  }
  invitedData?: {
    firstName: string
  }
}

const artistBalanceHistoryApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getArtistBalanceHistory: builder.query<ArtistBalanceItem[], void | null>({
      query: () => `${APP.TIKTOK_SERVER}/artist/balance/details`,
      transformResponse: (response: ArtistBalanceItemResponse[]) => {
        if (!response) {
          return []
        }
        return response.map((item, index) => {
          let transactionType: TransactionTypeEnum
          if (item.typeTransaction === 'refunded') {
            transactionType = TransactionTypeEnum.RECEIVED
          } else if (
            item.typeTransaction === PaymentStatusEnum.PAYED ||
            item.typeTransaction === PaymentStatusEnum.COMPLETED
          ) {
            transactionType = TransactionTypeEnum.PAYMENT
          } else if (item.typeTransaction === PaymentStatusEnum.CHARGED_BACK) {
            transactionType = TransactionTypeEnum.CHARGEBACK
          } else if (item.typeTransaction === PaymentStatusEnum.COUPON_BONUS) {
            transactionType = TransactionTypeEnum.COUPON_BONUS
          } else {
            transactionType = item.typeTransaction as TransactionTypeEnum
          }

          return {
            transactionType,
            id: `${item.campaignId ?? 0}${item.typeTransaction}${index}`,
            date: _dayjs(item.createdAt).format(formatDate.formatDateFirst),
            createdAt: item.createdAt,
            track: {
              trackName: item.trackName,
              trackAuthorName: item.artistName,
            },
            amount: Math.abs(Number(item.amount)),
            packageName: item.packageName,
            campaignId: item.campaignId,
            platformType: item.platformType,
            referralData: item.referralData,
            invitedData: item.invitedData,
          }
        })
      },
    }),
  }),
})

interface GetIsArtistNotFromInvitedLink {
  data?: ArtistBalanceItem[]
  isSuccess: boolean
}

export const getIsArtistNotFromInvitedLink = ({
  data,
  isSuccess,
}: GetIsArtistNotFromInvitedLink): { isArtistNotFromInvitedLink: boolean } => {
  if (!isSuccess) {
    return { isArtistNotFromInvitedLink: false }
  }

  const isInvitedBonus = data?.some(
    (item) => item.transactionType === TransactionTypeEnum.INVITED_BONUS,
  )

  return { isArtistNotFromInvitedLink: !isInvitedBonus }
}

export const { useGetArtistBalanceHistoryQuery } = artistBalanceHistoryApi
